/**
 * useActiveRoster — this workspace's active_roster (agent identities) for the
 * Team page, read from GET /api/workspace/mentionables (`agents`).
 *
 * track:mention-roster (spec #51157): was a direct browser read of the global
 * `team_log_context/active_roster` doc, which is shared by every workspace.
 *
 * `useActiveRoster()` returns `string[]` — empty until the first response
 * resolves. `useActiveRosterState()` also exposes `error` + `retry`, so
 * callers can tell "couldn't load" apart from "genuinely empty"
 * (track:small-fixes-1).
 */

import { useMentionables } from "./useMentionables";

export interface ActiveRosterState {
  roster: string[];
  /** Set while the mentionables fetch is failing; cleared on the next good response. */
  error: Error | null;
  /** Re-fetches immediately (e.g. from a "Try again" button). */
  retry: () => void;
}

export function useActiveRosterState(workspaceId = "default"): ActiveRosterState {
  const { agents, error, retry } = useMentionables(workspaceId);
  return { roster: agents, error, retry };
}

export function useActiveRoster(workspaceId = "default"): string[] {
  return useMentionables(workspaceId).agents;
}
